import React from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground = ({ children, className = '' }) => {
  // Generate random positions for floating elements
  const floatingElements = Array.from({ length: 6 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    scale: 0.3 + Math.random() * 0.7,
    duration: 15 + Math.random() * 10,
  }));

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/3 via-background to-accent/2" />
      {/* Floating geometric elements */}
      <div className="absolute inset-0 pointer-events-none">
        {floatingElements?.map((element) => (
          <motion.div
            key={element?.id}
            className="absolute w-20 h-20 rounded-full bg-gradient-to-r from-primary/10 to-accent/10 blur-xl"
            style={{
              left: `${element?.x}%`,
              top: `${element?.y}%`,
              transform: `scale(${element?.scale})`,
            }}
            animate={{
              x: [0, 50, -30, 0],
              y: [0, -40, 30, 0],
              rotate: [0, 180, 360],
            }}
            transition={{
              duration: element?.duration,
              repeat: Infinity,
              ease: "linear"
            }}
          />
        ))}
      </div>
      {/* Grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-[0.015] pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(rgba(59, 130, 246, 0.5) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59, 130, 246, 0.5) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}
      />
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default AnimatedBackground;